export default __webpack_public_path__ + "static/1contenido_eden-e664ffd9f3f9e5ec4907e0fbc20f4867.png";